import { render } from "./LivescoringRPR.vue?vue&type=template&id=227e8c58&scoped=true"
import script from "./LivescoringRPR.vue?vue&type=script&lang=js"
export * from "./LivescoringRPR.vue?vue&type=script&lang=js"

import "./LivescoringRPR.vue?vue&type=style&index=0&id=227e8c58&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227e8c58"]])

export default __exports__